import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
/**
 * Analytics Api: screenEvent.
 * @param {object} ScreenEventParams Object with the screen event details.
 * @param {string|forwardSlash} ScreenEventParams.screenId ( use/forwardSlash ) Screen identifier.
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event. Keys must be allow listed for data to be emitted from the app.
 * </table>
 *
 * @example
 * import { screenEvent } from "@octagon/public-analytics";
 *
 * // firing a screen event for non-SPA pages (no screen id required)
 * screenEvent();
 *
 * // non-SPA page reporting WITH additional payload data
 * screenEvent({}, { devSpecifiedData: "1625254612928" })
 *
 * // With NO additional payload data
 * screenEvent({ screenId: "/my/screen/id" });
 *
 * // With additional payload data
 * screenEvent(
 *   { screenId: "/my/screen/id" },
 *   { devSpecifiedData: "1625254612928" }
 * );
 *
 * @category Events
 */
export function screenEvent(params, customPayload) {
    if (params === void 0) { params = {}; }
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.SCREEN, params, customPayload);
}
